export const getAllProcess = (fetch: Client.HttpClient) => () =>
  fetch.get<Sentinel.Processes.GetAllProcessesResponse[]>("/api/process");

export const getProcessById = (fetch: Client.HttpClient) => (id: string) =>
  fetch.get<Sentinel.Processes.GetProcessByIdResponse>(`/api/process/${id}`);

export const createProcess =
  (fetch: Client.HttpClient) => (data: Sentinel.Processes.CreateRequest) =>
    fetch.post("/api/process", { body: data });

export const editProcess =
  (fetch: Client.HttpClient) =>
  (id: number | string, data: Sentinel.Processes.EditRequest) =>
    fetch.put(`/api/process/${id}`, { body: data });

export const deleteProcess =
  (fetch: Client.HttpClient) => (id: number | string) =>
    fetch.delete(`/api/process/${id}`);

export const createNonExecution =
  (fetch: Client.HttpClient) =>
  (processDefinitionId: number, data: Sentinel.NonExecution.Request) =>
    fetch.post<Sentinel.NonExecution.Request, Sentinel.NonExecution.Response>(
      `/api/process/${processDefinitionId}/nonExecution`,
      { body: data }
    );
